import React from 'react';
import { getUserToken } from 'services/token';
import urlJoin from 'url-join';
import { getEnv } from 'services/env-service';

export default function Phase3() {
  return (
    <iframe
      src={`${urlJoin(
        getEnv('REACT_APP_ACG_BASE_URL'),
        'phase-2',
      )}?token=${getUserToken()}`}
      style={{ width: '100%', border: 0, minHeight: '100%' }}
    />
  );
}
